import { z } from 'zod';
import {
  AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE,
  type AiEmbeddingModelNamePrismaKey,
} from './ai-model-name-prisma-to-wire';

type AiEmbeddingModelNameWireValue =
  (typeof AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE)[AiEmbeddingModelNamePrismaKey];

export const AI_EMBEDDING_MODEL_NAME_WIRE_VALUES = Object.values(
  AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE,
) as [AiEmbeddingModelNameWireValue, ...AiEmbeddingModelNameWireValue[]];

export const AiEmbeddingModelNameWireSchema = z.enum(
  AI_EMBEDDING_MODEL_NAME_WIRE_VALUES,
);

export type AiEmbeddingModelNameWire = z.infer<
  typeof AiEmbeddingModelNameWireSchema
>;

export const isAiEmbeddingModelNameWire = (
  value: unknown,
): value is AiEmbeddingModelNameWire =>
  AiEmbeddingModelNameWireSchema.safeParse(value).success;

export const isAiEmbeddingModelNamePrismaKey = (
  modelName: string,
): modelName is AiEmbeddingModelNamePrismaKey =>
  Object.hasOwn(AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE, modelName);

export const EMBEDDING_MODEL_NAMES = AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE;

const AI_EMBEDDING_MODEL_NAME_WIRE_TO_PRISMA_KEY = Object.fromEntries(
  (
    Object.entries(AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE) as [
      AiEmbeddingModelNamePrismaKey,
      AiEmbeddingModelNameWire,
    ][]
  ).map(([key, wire]) => [wire, key]),
) as Record<AiEmbeddingModelNameWire, AiEmbeddingModelNamePrismaKey>;

export const aiEmbeddingModelNameWireToPrismaKey = ({
  modelName,
}: {
  modelName: AiEmbeddingModelNameWire;
}): AiEmbeddingModelNamePrismaKey =>
  AI_EMBEDDING_MODEL_NAME_WIRE_TO_PRISMA_KEY[modelName];

export const aiEmbeddingModelNamePrismaKeyToWire = ({
  modelName,
}: {
  modelName: string;
}): AiEmbeddingModelNameWire => {
  const wire =
    AI_EMBEDDING_MODEL_NAME_PRISMA_TO_WIRE[
      modelName as AiEmbeddingModelNamePrismaKey
    ];

  return AiEmbeddingModelNameWireSchema.parse(wire);
};
